import { render, staticRenderFns } from "./make_sale.vue?vue&type=template&id=1b0dcff4&scoped=true&"
import script from "./make_sale.vue?vue&type=script&lang=js&"
export * from "./make_sale.vue?vue&type=script&lang=js&"
import style0 from "./make_sale.vue?vue&type=style&index=0&id=1b0dcff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dcff4",
  null
  
)

export default component.exports